import { createI18n } from 'vue-i18n';
import ar from './locales/ar.json';
import bg from './locales/bg.json';
import bn from './locales/bn.json';
import cs from './locales/cs.json';
import da from './locales/da.json';
import de from './locales/de.json';
import el from './locales/el.json';
import en from './locales/en.json';
import es from './locales/es.json';
import et from './locales/et.json';
import fi from './locales/fi.json';
import fr from './locales/fr.json';
import ga from './locales/ga.json';
import hi from './locales/hi.json';
import hr from './locales/hr.json';
import hu from './locales/hu.json';
import it from './locales/it.json';
import lt from './locales/lt.json';
import lv from './locales/lv.json';
import mt from './locales/mt.json';
import nl from './locales/nl.json';
import pl from './locales/pl.json';
import pt from './locales/pt.json';
import ro from './locales/ro.json';
import roMD from './locales/ro-MD.json';
import sk from './locales/sk.json';
import sl from './locales/sl.json';
import sv from './locales/sv.json';
import zhHans from './locales/zh-Hans.json';

const messages = {
  ar,
  bg,
  bn,
  cs,
  da,
  de,
  el,
  en,
  es,
  et,
  fi,
  fr,
  ga,
  hi,
  hr,
  hu,
  it,
  lt,
  lv,
  mt,
  nl,
  pl,
  pt,
  ro,
  'ro-MD': roMD,
  sk,
  sl,
  sv,
  'zh-Hans': zhHans,
};

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: navigator.language,
  fallbackLocale: 'en',
  messages,
});

export default i18n;
